import { useWindowDimensions } from "../../utils/utils";
import Banner from "../../components/layout/banner";
import { useNavigate, useParams } from "react-router-dom"; // Keep useNavigate as it's a common pattern for navigation
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  WhatsApp,
  CallSharp,
  ChevronLeft,
  ChevronRight,
  Close,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";
import { RootState } from "../../app/store";
import { formatMoney } from "../../utils/format";
import Button from "../../components/form/button";
import Modal from "../../components/common/modal";
import Transaction from "../../components/ux/transaction";
import Validation from "../../components/ux/order-validation";
import {
  dismissValidationModal,
  toggleValidationModal,
  toggleTransactionModal,
  dismissTransactionModal,
} from "../../features/payments/paymentsSlice";
import { useQuery } from "@apollo/client";
import { PRODUCT, PRODUCTS_BY_IDS } from "../../api/product/queries";
import { CommentSection } from "./comment";
import Header from "../../components/layout/header";
import UpSell from "../../components/ux/upsell";
import FloatingButton from "../../components/common/floating-button"; // UpSell component itself
import {
  dismissUpSalesModal,
  toggleUpSalesModal,
} from "../../features/products/productsSlice";
// import LazyMultilingualAudioPlayer from "../../components/common/lazy-multilingual-audio-player";
import audioTrackFr from "../../assets/tracks/audio.m4a";

interface Props {}

// Helper function to calculate the selling price based on quantity
const getSellingPrice = (basePrice, quantity, priceForTwo, priceForThree) => {
  switch (quantity) {
    case 1:
      return basePrice;
    case 2:
      return priceForTwo;
    case 3:
      return priceForThree;
    default:
      // For quantities greater than 3, apply a general discount or calculate based on base price
      // This logic assumes a 1000 FCFA discount per unit for quantities > 3
      return basePrice * quantity - 1000 * quantity;
  }
};

function MAITYSERUM(props: Props) {
  const navigate = useNavigate(); // Kept navigate as it's a standard hook
  const dispatch = useAppDispatch();
  const { productId } = useParams();
  const { data, loading, error } = useQuery(PRODUCT, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      productId: "68d2aa374b32565312635ffb", // Updated to MINOXIDIL's product ID
    },
  });

  const { width } = useWindowDimensions();
  const [state, setState] = useState({
    loaded: false,
    quantity: 1,
    lineClamp: false, // Set to false to make it open by default
    showMoreOrLess: "Voir Moins", // Set to "Voir Moins" to match open state
    product: {
      _id: "68d2aa374b32565312635ffb",
      shop: {
        _id: "63d12a74fe7b1e352d970f18",
      },
      name: "MAÏTY'S SERUM",
      price: 7000,
      previousPrice: 10000,
      price_for_two: 13000,
      price_for_three: 18000,
      selling_for: 10000, // Initial selling price for quantity 1
      uri: "https://vertus-organic.web.app/maityserum",
    },
  });

  const slideIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const isValidationModalOpen = useAppSelector(
    (state: RootState) => state.payments.isValidationModalOpen
  );

  const isTransactionModalOpen = useAppSelector(
    (state: RootState) => state.payments.isTransactionModalOpen
  );

  const upSalesModalIsOpen = useAppSelector(
    (state: RootState) => state.products.product.upSalesModalIsOpen
  );

  const images = [
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/11.png?sp=r&st=2025-08-22T16:04:24Z&se=2029-08-23T00:19:24Z&sv=2024-11-04&sr=b&sig=q3vZeyiHSWypOGrdy3KlEKl9RGK9u%2FtGfDUcxUqqyqk%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/01.png?sp=r&st=2025-08-22T15:53:23Z&se=2029-08-23T00:08:23Z&sv=2024-11-04&sr=b&sig=%2BEz8cztMMjAsxofZkFeAtS1DuRAWewLbm7aC0Ycb9Ng%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/19.png?sp=r&st=2025-08-23T18:40:45Z&se=2029-08-24T02:55:45Z&sv=2024-11-04&sr=b&sig=qLT7FpL1dkWBZzK6lu32qnjgozutSuZ3rS3CzwPp7AI%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/03.png?sp=r&st=2025-08-22T15:55:10Z&se=2029-08-23T00:10:10Z&sv=2024-11-04&sr=b&sig=UJhNl8AHHBGNjBK2a5%2FWvujhMInqHDE8zqyLnBKWbZs%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/04.png?sp=r&st=2025-08-22T16:07:14Z&se=2029-08-23T00:22:14Z&sv=2024-11-04&sr=b&sig=ksL4vbsEfO4Nx3Wyc4hry%2FI3TE5f%2FyWBiOvWhFU9bhU%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/05.png?sp=r&st=2025-08-22T16:08:06Z&se=2029-08-23T00:23:06Z&sv=2024-11-04&sr=b&sig=RPzbdIZk2blIl4THzfy4vst1elzVrupl76SlVqJZgGY%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/07.png?sp=r&st=2025-08-22T16:08:47Z&se=2029-08-23T00:23:47Z&sv=2024-11-04&sr=b&sig=dHUxvVpgTAlOA1wZjz7m3VF2LfIDAQQqO1Sk5vo%2BxC4%3D",
    "https://newhackerway.blob.core.windows.net/images/Maityhaircare/13.png?sp=r&st=2025-08-22T16:38:46Z&se=2029-08-23T00:53:46Z&spr=https&sv=2024-11-04&sr=b&sig=Q3%2BjIOvV8HzTVNrsuyxonEoQP6hK2fiZ%2FXM3jq7iF8w%3D",
  ];

  // Centralized function to update quantity and selling price
  const updateQuantityAndPrice = (newQuantity) => {
    setState((prevState) => {
      // Ensure quantity doesn't go below 1
      const effectiveQuantity = Math.max(1, newQuantity);

      const newSellingFor = getSellingPrice(
        prevState.product.price,
        effectiveQuantity,
        prevState.product.price_for_two,
        prevState.product.price_for_three
      );

      return {
        ...prevState,
        quantity: effectiveQuantity,
        product: {
          ...prevState.product,
          selling_for: newSellingFor,
        },
      };
    });
  };

  const handleSetQuantity = (quantity) => {
    updateQuantityAndPrice(quantity);
  };

  const handleDecreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity - 1);
  };

  const handleIncreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity + 1);
  };

  const handleSubmit = (e: any) => {
    dispatch(toggleValidationModal());
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const slideRef = useRef<HTMLDivElement>(null);
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);

  const handleChevronLeft = useCallback(() => {
    const size = images?.length;
    setCurrentIndex((prevIndex) => (prevIndex + size - 1) % size);
  }, [images?.length]);

  const handleChevronRight = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
  }, [images?.length]);

  const pauseSlider = useCallback(() => {
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
  }, []);

  const startSlider = useCallback(() => {
    pauseSlider();
    slideIntervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
    }, 5000);
  }, [images?.length, pauseSlider]);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback(() => {
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        handleChevronRight();
      } else {
        handleChevronLeft();
      }
    }
  }, [handleChevronLeft, handleChevronRight]);

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        handleChevronLeft();
      } else if (e.key === "ArrowRight") {
        handleChevronRight();
      } else if (e.key === "Escape" && isFullscreen) {
        setIsFullscreen(false);
      }
    },
    [handleChevronLeft, handleChevronRight, isFullscreen]
  );

  useEffect(() => {
    startSlider();
    if (slideRef.current) {
      slideRef.current.addEventListener("mouseenter", pauseSlider);
      slideRef.current.addEventListener("mouseleave", startSlider);
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      pauseSlider();
      if (slideRef.current) {
        slideRef.current.removeEventListener("mouseenter", pauseSlider);
        slideRef.current.removeEventListener("mouseleave", startSlider);
      }
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [startSlider, pauseSlider, handleKeyDown]);

  const toggleLineClamp = () => {
    setState((prevState) => ({
      ...prevState,
      lineClamp: !prevState.lineClamp,
      // Corrected logic: if lineClamp is now TRUE (clamped), show "Voir Plus".
      // If lineClamp is now FALSE (not clamped), show "Voir Moins".
      showMoreOrLess: !prevState.lineClamp ? "Voir Plus" : "Voir Moins",
    }));
  };

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);

  const ImageGridItem = () => {
    return (
      <div className="relative">
        <img
          onLoad={() => {
            setState((prevState) => ({ ...prevState, loaded: true }));
          }}
          src={images[currentIndex]}
          loading="lazy"
          alt={`${state?.product?.name} - Image ${currentIndex + 1} sur ${
            images?.length
          }`}
          style={{
            width: "100%",
            maxHeight: "80vh",
            minWidth: "0",
            objectFit: "cover",
          }}
          role="img"
          aria-label={`Image ${currentIndex + 1} de ${
            images?.length
          } du produit ${state?.product?.name}`}
          onContextMenu={(e) => e.preventDefault()}
        />
        <button
          onClick={toggleFullscreen}
          className="absolute bottom-2 right-2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 transition-all"
          aria-label="Afficher en plein écran"
          title="Afficher en plein écran (Cliquer sur l'image)"
        >
          <Fullscreen />
        </button>
      </div>
    );
  };

  const FullscreenModal = () => {
    if (!isFullscreen) return null;
    return (
      <div
        className="fixed inset-0 z-[9999] bg-black bg-opacity-95 flex items-center justify-center"
        onClick={toggleFullscreen}
        role="dialog"
        aria-modal="true"
        aria-label="Visualisation en plein écran"
      >
        <div className="relative w-full h-full flex items-center justify-center">
          <button
            onClick={toggleFullscreen}
            className="absolute top-4 right-4 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 z-10 transition-all"
            aria-label="Fermer le plein écran (Échap)"
            title="Fermer (Échap)"
          >
            <Close fontSize="large" onClick={toggleFullscreen} />
          </button>
          {images?.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronLeft();
                }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image précédente"
                title="Image précédente (Flèche gauche)"
              >
                <ChevronLeft fontSize="large" />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronRight();
                }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image suivante"
                title="Image suivante (Flèche droite)"
              >
                <ChevronRight fontSize="large" />
              </button>
            </>
          )}
          <img
            src={images[currentIndex]}
            alt={`${state?.product?.name} - Image ${currentIndex + 1} sur ${
              images?.length
            }`}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
          />
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-75 px-4 py-2 rounded-full">
            <span className="font-semibold">
              {currentIndex + 1} / {images?.length}
            </span>
          </div>
          {images?.length > 1 && (
            <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex gap-1 overflow-x-auto min-w-[70vw] max-w-[90vw] scrollbar-hide">
              {images.map((img, i) => (
                <button
                  key={i}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex(i);
                  }}
                  className={`flex-shrink-0 border-2 rounded transition-all ${
                    currentIndex === i
                      ? "border-white ring-2 ring-white"
                      : "border-transparent opacity-60 hover:opacity-100"
                  }`}
                >
                  <img
                    src={img}
                    alt={`Miniature ${i + 1}`}
                    className="w-16 h-16 object-cover rounded"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const {
    data: products,
    fetchMore,
    networkStatus,
    refetch,
  } = useQuery(PRODUCTS_BY_IDS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      first: 50,
      productIds: [
        "66841b202d2d08dfc58d733d", // Example related product
        "66841bab2d2d08dfc58d7342", // Example related product
        "66841adb2d2d08dfc58d7338", // Example related product
        "68d2a91b1c0fde807d6022e6", // Example related product
      ],
    },
  });

  return (
    <>
      <FullscreenModal />
      <Modal
        modalIsOpen={upSalesModalIsOpen}
        className="w-4/5 md:w-3/5" // Changed from original MINOXIDIL code to match LXRMIMI's CardList modal width
        dismissModal={() => dispatch(dismissUpSalesModal())}
        handleModal={() => dispatch(toggleUpSalesModal())}
        content={<UpSell products={products?.productsByIds?.page?.edges} />}
      />
      <Modal
        modalIsOpen={isValidationModalOpen}
        className="w-4/5 md:w-3/12"
        dismissModal={() => dispatch(dismissValidationModal())}
        content={
          <Validation
            pixelId="1290489315765991"
            handleDismiss={() => dispatch(dismissValidationModal())}
            item={{ ...state.product, quantity: state.quantity }}
          />
        }
      />
      {/* The Grid */}
      <div
        className="mx-auto grid min-h-screen"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gridTemplateRows: "5em auto",
        }}
      >
        {/* Header */}
        {/* Header Hack */}
        <div className="header"></div>
        <div className="fixed top-0 left-0 right-0 z-50 bg-white w-full">
          <Banner className="bg-djeliba" />
          <Header />
        </div>
        {/* Content */}
        <div
          style={{
            gridColumn: "1 / -1",
          }}
        >
          <div className="flex flex-col my-5 md:flex-row justify-around items-start">
            <div className="w-full md:w-1/3 border relative">
              <div
                ref={slideRef}
                className="w-full select-none relative"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                role="region"
                aria-label="Carousel d'images du produit"
                aria-live="polite"
              >
                <div className="w-full flex-row flex justify-evenly items-center">
                  <figure className="md:h-full grow md:m-2.5">
                    {ImageGridItem()}
                  </figure>
                </div>
                {images?.length > 1 && (
                  <>
                    <div
                      className="absolute md:my-0 my-4 flex w-full md:flex-col md:w-1/6 md:h-full md:overflow-y-auto overflow-scroll scrollbar-hide md:-left-16 md:-top-1 md:px-3 justify-start items-center bg-transparent"
                      role="tablist"
                      aria-label="Miniatures des images"
                    >
                      {images.map((item, i) => (
                        <button
                          key={i}
                          className={`border rounded md:my-1 hover:border-2 md:w-full min-w-14 mx-1 transition-all ${
                            currentIndex === i
                              ? "border-djeliba border-2 ring-2 ring-djeliba"
                              : "border-djeliba"
                          }`}
                          onClick={() => setCurrentIndex(i)}
                          onMouseEnter={() => setCurrentIndex(i)}
                          role="tab"
                          aria-selected={currentIndex === i}
                          aria-label={`Afficher image ${i + 1}`}
                          title={`Image ${i + 1}`}
                        >
                          <img
                            src={images[i]}
                            alt={`Miniature ${i + 1}`}
                            loading="lazy"
                            style={{
                              width: "100%",
                              maxHeight: "80vh",
                              minWidth: "0",
                              objectFit: "cover",
                            }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className="w-full px-1 flex justify-between items-center">
                <div className="flex max-w-min">
                  <a
                    className="text-green-500 top-0 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`tel:${221773808340}`}
                  >
                    <CallSharp
                      className="border rounded-md p-1 text-blue-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                  <a
                    className="text-green-500 top-11 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://api.whatsapp.com/send?phone=${221773808340}&text=${encodeURIComponent(
                      "Je souhaite commander l'article : " +
                        state?.product?.name +
                        "\n\nLien : " +
                        state?.product?.uri
                    )}`}
                  >
                    <WhatsApp
                      className="border rounded-md text-green-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                </div>
                {images?.length > 1 && (
                  <div
                    className="flex w-full h-5 justify-center items-center"
                    role="group"
                    aria-label="Indicateurs de progression du carousel"
                  >
                    {images?.map((item, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentIndex(i)}
                        className={
                          currentIndex === i
                            ? "bg-black h-1.5 w-1.5 rounded-full ml-1 cursor-pointer hover:scale-150 transition-transform"
                            : "bg-slate-400 h-1 w-1.5 rounded-sm ml-1 cursor-pointer hover:bg-slate-600 transition-colors"
                        }
                        aria-label={`Aller à l'image ${i + 1}`}
                        aria-current={currentIndex === i ? "true" : "false"}
                        title={`Image ${i + 1}`}
                      ></button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="w-full mt-14 md:mt-0 md:w-1/2 h-full md:border hover:border-0">
              <div className="mx-2 my-3">
                {/* <LazyMultilingualAudioPlayer
                  tracks={{
                    wo: audioTrackFr,
                    pl: audioTrackFr,
                    fr: audioTrackFr,
                  }}
                  languageLabels={{
                    wo: "Wolof",
                    pl: "Pulaar",
                    fr: "Français",
                  }}
                /> */}
              </div>
              <div className="flex justify-around md:justify-between items-center mb-2">
                <div id="product-name-container">
                  <div className="m-2">
                    <span className="font-bold text-lg md:text-3xl">
                      {state?.product?.name}
                    </span>
                  </div>
                  <div className="m-2">
                    <span className="font-bold text-yellow-500 md:text-xl">
                      Livraison gratuite
                    </span>
                  </div>
                  <div className="m-2 my-3">
                    <div
                      className={
                        state.quantity === 1
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-pink-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(1)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Maityhaircare/11.png?sp=r&st=2025-08-22T16:04:24Z&se=2029-08-23T00:19:24Z&sv=2024-11-04&sr=b&sig=q3vZeyiHSWypOGrdy3KlEKl9RGK9u%2FtGfDUcxUqqyqk%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥
                          <span>1</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-pink-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice - state.product.price
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 2
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-pink-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(2)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Maityhaircare/11.png?sp=r&st=2025-08-22T16:04:24Z&se=2029-08-23T00:19:24Z&sv=2024-11-04&sr=b&sig=q3vZeyiHSWypOGrdy3KlEKl9RGK9u%2FtGfDUcxUqqyqk%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥
                          <span>2</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price_for_two)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-pink-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 2}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 2 -
                                state.product.price_for_two
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 3
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-pink-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(3)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Maityhaircare/11.png?sp=r&st=2025-08-22T16:04:24Z&se=2029-08-23T00:19:24Z&sv=2024-11-04&sr=b&sig=q3vZeyiHSWypOGrdy3KlEKl9RGK9u%2FtGfDUcxUqqyqk%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥🔥
                          <span>3</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(
                              state?.product?.price_for_three
                            )}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-pink-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 3}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 3 -
                                state.product.price_for_three
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-col justify-evenly items-center">
                  <div className="flex justify-center items-center">
                    <span
                      onClick={handleDecreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-black bg-djeliba text-xl"
                    >
                      -
                    </span>
                    <span className="font-bold rounded-sm px-1 mx-1 bg-black text-white text-lg">
                      {state.quantity}
                    </span>
                    <span
                      onClick={handleIncreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-pink-500 bg-djeliba text-xl"
                    >
                      +
                    </span>
                  </div>
                  <div className="px-2">
                    <Button
                      title="Commander"
                      isWaiting={false}
                      handleOnClick={(e) => handleSubmit(e)}
                      disabled={false}
                      className="hover:shadow-2xl cursor-pointer hover:transition-all ease-linear duration-300"
                    />
                  </div>
                </div>
              </div>
              <div className="mx-2">
                {state.lineClamp ? (
                  <p
                    className="border-none w-full outline-none text-sm px-2 py-1 rounded-md ml-1"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      overflow: "hidden",
                    }}
                    onClick={toggleLineClamp}
                  >
                    MAITY'S SERUM Redonnez vie à vos cheveux. Perdre ses cheveux
                    peut être difficile à vivre. MAITY'S POUSSE + est un
                    traitement local reconnu pour son efficacité contre la chute
                    de cheveux. Utilisé depuis plusieurs années pour le
                    traitement des cheveux, ses composants stimulent directement
                    les follicules pileux et favorise une repousse visible et
                    durable. C’est la solution idéale pour celles et ceux qui
                    veulent retrouver une chevelure plus dense, plus forte, sans
                    intervention lourde ni traitement complexe.
                  </p>
                ) : (
                  <div className="flex-row" onClick={toggleLineClamp}>
                    MAITY'S SERUM Redonnez vie à vos cheveux.
                    <p className="">
                      Perdre ses cheveux peut être difficile à vivre. MAITY'S
                      POUSSE + est un traitement local reconnu pour son
                      efficacité contre la chute de cheveux. Utilisé depuis
                      plusieurs années pour le traitement des cheveux, ses
                      composants stimulent directement les follicules pileux et
                      favorise une repousse visible et durable. C’est la
                      solution idéale pour celles et ceux qui veulent retrouver
                      une chevelure plus dense, plus forte, sans intervention
                      lourde ni traitement complexe.
                    </p>
                    <div className="m-1">
                      <h2 className="text-lg">
                        💡 Ce que MAITY'S POUSSE + SERUM peut faire pour vous :
                      </h2>
                      <ul className="list-disc ml-6">
                        <li>
                          ✅ Ralentit la chute des cheveux dès les premières
                          semaines
                        </li>
                        <li>
                          ✅ Favorise la repousse dans les zones dégarnies (haut
                          du crâne, tempes, etc.)
                        </li>
                        <li>✅ Convient aux hommes comme aux femmes</li>
                        <li>
                          ✅ Améliore la densité et l’épaisseur des cheveux
                        </li>
                        <li>✅ Facile à utiliser, à la maison</li>
                        Que votre perte de cheveux soit liée à l’âge, au stress
                        ou à l’hérédité (alopécie androgénétique), MAITY'S
                        POUSSE + SERUM peut vous aider à reprendre le contrôle.
                      </ul>
                      <div className="flex p-2 justify-center items-center">
                        <div className="flex justify-between items-center p-1">
                          <img
                            src="https://newhackerway.blob.core.windows.net/images/Maityhaircare/08.png?sp=r&st=2025-08-22T16:11:42Z&se=2029-08-23T00:26:42Z&sv=2024-11-04&sr=b&sig=fAnrHS07e1tedLCYACJqF4IELj5Bn7Oh2qqKA1i3OEs%3D"
                            alt=""
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </div>
                        <div className="flex justify-between items-center p-1">
                          <img
                            src="https://newhackerway.blob.core.windows.net/images/Maityhaircare/11.png?sp=r&st=2025-08-22T16:04:24Z&se=2029-08-23T00:19:24Z&sv=2024-11-04&sr=b&sig=q3vZeyiHSWypOGrdy3KlEKl9RGK9u%2FtGfDUcxUqqyqk%3D"
                            alt=""
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">📌 Comment l’utiliser ?</h2>
                      <ul className="list-disc ml-6">
                        <li>
                          Appliquer le serum directement sur le cuir chevelu
                          matin et soir 3 fois par semaine.
                        </li>
                        <li>Masser doucement et laisser sécher.</li>
                        <li>
                          Les premiers résultats sont souvent visibles entre 3
                          et 6 semaines.
                        </li>
                        ⚠️ Une application régulière est essentielle pour
                        obtenir et conserver les effets.
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Maityhaircare/07.png?sp=r&st=2025-08-22T16:08:47Z&se=2029-08-23T00:23:47Z&sv=2024-11-04&sr=b&sig=dHUxvVpgTAlOA1wZjz7m3VF2LfIDAQQqO1Sk5vo%2BxC4%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">
                        🌿 100% Naturel – Sans effets secondaires
                      </h2>
                      <ul className="list-disc ml-6">
                        <li>
                          MAITY'S POUSSE + SERUM est un traitement sans danger,
                          largement utilisé dans le monde entier. Il s’intègre
                          facilement à votre routine quotidienne et ne demande
                          aucun changement de mode de vie.
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Hair%20Now%20Now/69.png?sp=r&st=2025-07-08T14:08:12Z&se=2029-07-08T22:08:12Z&sv=2024-11-04&sr=b&sig=mZI%2Fm9lL6LMr%2BOZ1CtmWRk7GHq9IeKv1qhDk%2BEGfBEQ%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <span
                  className="text-sm font-thin text-gray-400 cursor-pointer"
                  onClick={toggleLineClamp}
                >
                  {state.showMoreOrLess}
                </span>
              </div>
              <div className="flex-col w-full mt-2 md:mt-0 h-full overflow-hidden">
                {/* Integrate the CommentSection component */}
                <CommentSection />
              </div>
            </div>
          </div>
        </div>
        {/* Recommendation */}
        <div
          className="p-0 my-2"
          style={{
            gridColumn: "1 / -1",
          }}
        >
          {/* Removed commented out Slider component */}
        </div>
        {/* Footer */}

        {/* Bouton flottant pour remonter en haut */}
        <FloatingButton targetSelector="#product-name-container" />
      </div>
    </>
  );
}

export default MAITYSERUM;
